import { ProduktDiameterfordelningDTO } from "~app/common/models/produkt/ProduktDiameterfordelningDTO";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { ValidationErrorLevels } from "~app/common/validation/ValidationErrorLevels";
import { ValidationScopes } from "~app/common/validation/ValidationScopes";
import { ValidationContext } from "~app/common/validation/validationContext";
import { ProduktDetailTexts } from "~app/features/forsaljning/produkt/produkt-detail/produkt-detail.texts";

export class DiameterfordelningModalValidation {
    static init(diameter: number, diameterfordelningar: ProduktDiameterfordelningDTO[], min: number, max: number): ValidationContext {
        const context = new ValidationContext();
        context.errorLevel = ValidationErrorLevels.error;
        context.create(ValidationScopes.spara).withRules([
            {
                errorLevel: ValidationErrorLevels.error,
                expression: (newValue) =>
                    !(ObjectUtils.isNullOrUndefined(newValue) ||
                    diameterfordelningar.some(p => p.diamBotten === newValue) ||
                    newValue < min ||
                    newValue > max ||
                    // eslint-disable-next-line sonarjs/concise-regex
                    !/^[0-9]+(\.[0-9]{1})?$/.test(newValue as string)),
                message: { text: ProduktDetailTexts.fordelningsmatrisTab.validation.diameterfordelningModalDiameter },
                model: () => diameter,
                name: "diameter"
            }
        ]);

        return context;
    }
}
